export const SERVERURL = "https://icamp.ecell.org.in/api";
// export const SERVERURL = "http://localhost:3000/api";
